import PasswordReset from "../components/Account/sign up & in/PasswordReset";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import { Pagination } from "swiper";
// import "swiper/css/pagination";

const ResetPassword = (props) => {
  return <PasswordReset isLoading={props.isLoading} loading={props.loading} />;
};

export default ResetPassword;

// const ResetPassword = () => {
//   return (
//     <Swiper
//       breakpoints={{
//         640: {
//           width: 640,
//           slidesPerView: 1,
//         },
//         768: {
//           width: 768,
//           slidesPerView: 3,
//         },
//       }}
//       // slidesPerView={2}
//       pagination={{
//         clickable: true,
//       }}
//       modules={[Pagination]}
//       className="mySwiper"
//     >
//       <SwiperSlide>
//         <h1>Swiper JS</h1>
//       </SwiperSlide>
//       <SwiperSlide>
//         <h1>Swiper JS</h1>
//       </SwiperSlide>
//       <SwiperSlide>
//         <h1>Swiper JS</h1>
//       </SwiperSlide>
//       <SwiperSlide>
//         <h1>Swiper JS</h1>
//       </SwiperSlide>
//     </Swiper>
//   );
// };

// export default ResetPassword;
